import { render, staticRenderFns } from "./ListItemClickIndicator.vue?vue&type=template&id=3480c6d0&"
import script from "./ListItemClickIndicator.vue?vue&type=script&lang=ts&"
export * from "./ListItemClickIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./ListItemClickIndicator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports